export default {
  signUp: {
    title: 'Register and View Job Openings',
    subtitle: 'Create Account',
    separator: 'Register with SNS Account',
    links: {
      termsPre: 'I agree to the ',
      terms: 'Terms of Use',
      termsPost: '',
      and: 'and',
      privacy: 'Handling Personal Information.',
      privacySuffix: '',
      loginPre: '',
      loginPre2: 'If you already have a GitTap Account, you can',
      login: 'Log in',
      loginSuffix: 'here',
      handlingPersonalInformation: 'Handling Personal Information.'
    },
    footer: {
      one: 'or sign in with account below',
      two: 'If you already have a GitTap Account, you can log in'
    },
    form: {
      email: {
        label: 'Email',
        placeholder: 'Please input your email'
      }
    },
    create: 'Create Account',
    validation: {
      password:
        'Password must be at least 8 characters of a combination of numbers and letters',
      required: 'Required.',
      confirm: 'Password and confirm password must be the same'
    },
    success: {
      title: 'Check your email to verify your account.',
      body: 'Sign up completed!',
      or: 'or',
      login: 'Login'
    },
    verified: {
      title: 'Your account has been verified!',
      body: 'Please continue to fill in your personal info and let us help you find your ideal job',
      failed: {
        title: 'Verification failed!',
        body: 'The URL is invalid or expired.',
        actionLabel: 'Register Again'
      }
    },
    social: {
      google: 'Continue with Google',
      facebook: 'Continue with Facebook',
      linkedIn: 'Continue with LinkedIn',
      github: 'Continue with Github'
    },
    tokenError:
      'This URL has been already used. Please request your inviter to send another URL'
  }
}
